
import React from 'react';
import { ERROR_UPDATE_CONFIG, NO_VALID_ENTRY, SUCCESS_UPDATE_TEXT } from '../../constants';
import { sendCloudWatchAlert } from '../../utils/applicationError';
import { showNotification } from '../Notification/Notification.view';
import { updateManagementFee } from '../../apis/backend';
import _ from 'lodash';

interface OrderTypeConfig {
    fee: number;
    maxFee: number;
    minFee: number;
    hasFixedValue: boolean | null;
}
interface ManagementFee {
    enabled: boolean;
    [key: string]: OrderTypeConfig | boolean;
}



export const initDataConfig = async (
    managementFee: ManagementFee,
    managementFeeData: ManagementFee,
    setState: React.Dispatch<React.SetStateAction<any>>
) => {
    _.map(managementFee, elm => {
        const fixedValue = elm.fee === elm.maxFee && elm.maxFee === elm.minFee
        _.assign(elm, { hasFixedValue: fixedValue });
    });
    setState(prevState => ({
        ...prevState,
        managementFeeData: managementFee ? managementFee : managementFeeData
    }));
};


export const handleToggle = (setState: React.Dispatch<React.SetStateAction<any>>, managementFeeData: any) => {
    setState(prevState => ({
        ...prevState,
        managementFeeData: {
            ...managementFeeData,
            enabled: !managementFeeData?.enabled
        }
    }));
};

export const handleCheckboxChange = (setState: React.Dispatch<React.SetStateAction<any>>, key: string) => {
    setState(prevState => ({
        ...prevState,
        managementFeeData: {
            ...prevState.managementFeeData,
            [key]: {
                ...prevState.managementFeeData[key],
                hasFixedValue: !prevState.managementFeeData[key].hasFixedValue
            }
        }
    }));
};



export const handleChange = (event: React.ChangeEvent<HTMLInputElement>, setState: React.Dispatch<React.SetStateAction<any>>, key: string) => {
    const { target } = event;
    setState(prevState => ({
        ...prevState,
        managementFeeData: {
            ...prevState.managementFeeData,
            [key]: {
                ...prevState.managementFeeData[key],
                [target.id]: target.value ? parseFloat(target.value) : target.value
            }
        }
    }));
};

export const handleSubmitData = async (
    setState: React.Dispatch<React.SetStateAction<any>>,
    managementFee: ManagementFee,
    openErrorModal: (message: string) => void
) => {
    const newManagementFee = _.cloneDeep(managementFee)

    const roundToTwoDecimals = (num) => {
        if (num) {
            return parseFloat(parseFloat(num).toFixed(2));
        }
        return num;
    };
    if (managementFee) {
        _.map(newManagementFee, elm => {
            if (elm.hasFixedValue) {
                elm.maxFee = elm.minFee = elm.fee;
            }
            delete elm.hasFixedValue;

            if (typeof elm === 'object' && elm !== null) {
                elm.fee = roundToTwoDecimals(elm.fee)
                elm.minFee = roundToTwoDecimals(elm.minFee)
                elm.maxFee = roundToTwoDecimals(elm.maxFee)
            }


        });
    }
    try {
        setState(prevState => ({ ...prevState, isLoading: true }));
        await updateManagementFee(newManagementFee)
        showNotification(
            'light',
            'ltr',
            'primary',
            SUCCESS_UPDATE_TEXT,
            'Les paramètres des frais de gestion ont bien été modifiés.'
        );
    } catch (error) {
        sendCloudWatchAlert(`Error changing order settings ${error}`);
        if (error?.includes('minFee > maxFee ')) openErrorModal(NO_VALID_ENTRY);
        else openErrorModal(ERROR_UPDATE_CONFIG)
    }
    setState(prevState => ({ ...prevState, isLoading: false }));

};

export const checkMinMaxValue = ({ target }: any, setState: React.Dispatch<React.SetStateAction<any>>, min: number, key: string,
) => {
    let { value } = target;
    if (parseFloat(value) < min) {
        target.value = min;
    }
    setState(prevState => ({
        ...prevState,
        managementFeeData: {
            ...prevState.managementFeeData,
            [key]: {
                ...prevState.managementFeeData[key],
                [target.id]: target.value
            }
        }
    }));
};
